<template>
  <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify="validate"/>
</template>
<script>
import {VueRecaptcha} from 'vue-recaptcha';
import RecaptchaValidate from '../../utils/recaptchaValidate';

export default {
  components: {VueRecaptcha},
  data () {
    return {
      sitekey: process.env.RECAPTCHA_SITE_KEY
    };
  },
  methods: {
    validate (response) {
      RecaptchaValidate.validate({Response: response}).then(result => {
        this.$emit('validate', result);
      }).catch(error => console.log(error));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Login/Recaptcha.vue